// extracted by mini-css-extract-plugin
export default {"sectionprogressscreen-wrapper":"SectionProgressScreen_sectionprogressscreen-wrapper__Hp9ck"};